import { xenvActionFactory } from '../xenv';
import { 
// alimpSaveImg,
// alipaySaveImg,
// bdmpSaveImg,
// cappSaveImg,
// cowxmpSaveImg,
// cxwxmpSaveImg,
driverSaveImg, 
// drwxmpSaveImg,
// gjwxmpSaveImg,
// h5SaveImg,
// kfalimpSaveImg,
kfdriverSaveImg, 
// kfdwxmpSaveImg,
// kfpassengerSaveImg,
// kfwxmpSaveImg,
// mqqSaveImg,
passengerSaveImg, 
// qqmpSaveImg,
// thwxmpSaveImg,
// weixinSaveImg,
// wxmpSaveImg,
// yxwxmpSaveImg,
hitchappSaveImg, 
// yxwxmpSaveImg
hydriverSaveImg } from '../platform/xenv';
const xenvSaveImgConfig = {
    // 'alimp': alimpSaveImg, 
    // 'alipay': alipaySaveImg,
    // 'bdmp': bdmpSaveImg,
    // 'capp': cappSaveImg,
    // 'cowxmp': cowxmpSaveImg,
    // 'cxwxmp': cxwxmpSaveImg,
    'driver': driverSaveImg,
    // 'drwxmp': drwxmpSaveImg,
    // 'gjwxmp': gjwxmpSaveImg,
    // 'h5': h5SaveImg,
    // 'kfalimp': kfalimpSaveImg,
    'kfdriver': kfdriverSaveImg,
    // 'kfdwxmp': kfdwxmpSaveImg,
    // 'kfpassenger': kfpassengerSaveImg,
    // 'kfwxmp': kfwxmpSaveImg,
    // 'mqq': mqqSaveImg,
    'passenger': passengerSaveImg,
    // 'qqmp': qqmpSaveImg,
    // 'thwxmp': thwxmpSaveImg,
    // 'weixin': weixinSaveImg,
    // 'wxmp': wxmpSaveImg,
    // 'yxwxmp': yxwxmpSaveImg,
    'hitchapp': hitchappSaveImg,
    // 'yxwxmp': yxwxmpSaveImg
    'hydriver': hydriverSaveImg
};
export const saveImg = (url) => {
    const fn = xenvActionFactory('saveImg', xenvSaveImgConfig);
    return fn(url);
};
